import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  CruiseModel,
  CruiseMutationInput,
  CruiseDeleteInput,
  CruiseUpdateInput,
} from './model';

export function useCreateCruise(
  options?: UseMutationOptions<
    ApiResult<CruiseModel>,
    ApiError,
    CruiseMutationInput
  >,
): UseMutationResult<ApiResult<CruiseModel>, ApiError, CruiseMutationInput> {
  return useMutation<ApiResult<CruiseModel>, ApiError, CruiseMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'cruises',
        method: 'POST',
        classType: CruiseModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateCruise(
  options?: UseMutationOptions<
    ApiResult<CruiseModel>,
    ApiError,
    CruiseUpdateInput
  >,
): UseMutationResult<ApiResult<CruiseModel>, ApiError, CruiseUpdateInput> {
  return useMutation<ApiResult<CruiseModel>, ApiError, CruiseUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cruises/${body.cruiseId}`,
        method: 'PUT',
        classType: CruiseModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteCruise(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    CruiseDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, CruiseDeleteInput> {
  return useMutation<{ message: string }, ApiError, CruiseDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `cruises/${body.cruiseId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
